// extracted by mini-css-extract-plugin
export default {"svg":"SVG_svg__NXCAx"};